// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"card-image-type-5-m__wrapper__25dgi"};